import { find, propEq } from 'ramda';
import { i18n } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { SERVICE_ATTRIBUTE_DISPLAY_TYPES } from '../../../../../customercare.constants';
export var getRegexValidation = function getRegexValidation(attribute, attributeConfiguration, regexCodes) {
  var serviceAttribute = find(propEq(String(attribute.ServiceAttributeId), 'Value'))(attributeConfiguration);
  var val = null;
  if (serviceAttribute && serviceAttribute.AdditionalProperties) {
    serviceAttribute.AdditionalProperties.forEach(function (prop) {
      if (prop.Key === 'regex_code' && typeof prop.Value === 'string' && prop.Value.length > 0) {
        var regexCodeObject = find(propEq(String(prop.Value), 'Value'))(regexCodes);
        val = regexCodeObject.AdditionalProperties[0].Value;
      }
    });
  }
  return val;
};
export var getPossibleValues = function getPossibleValues(attribute, attributeConfiguration) {
  var serviceAttribute = find(propEq(String(attribute.ServiceAttributeId), 'Value'))(attributeConfiguration);
  var values = null;
  if (serviceAttribute) {
    serviceAttribute.AdditionalProperties.forEach(function (prop) {
      if (prop.Key === 'possible_values') {
        if (prop.Value.includes(',')) {
          values = formatMultipleValues(prop.Value.split(','));
        } else if (prop.Value && prop.Value !== '') {
          values = formatMultipleValues([prop.Value]);
        }
      }
    });
  }
  return values;
};
export var getIsRequired = function getIsRequired(attribute, attributeConfiguration) {
  var serviceAttribute = find(propEq(String(attribute.ServiceAttributeId), 'Value'))(attributeConfiguration);
  var isRequired = false;
  if (serviceAttribute) {
    serviceAttribute.AdditionalProperties.forEach(function (prop) {
      if (prop.Key === 'is_required') {
        isRequired = prop.Value === 'True';
      }
    });
  }
  return isRequired;
};
export var getDependentAttributes = function getDependentAttributes(attributes, attributeConfiguration) {
  var dependentAttributes = [];
  attributes.forEach(function (attr) {
    var attrConf = getCodeConfiguration(attr.ServiceAttributeId, attributeConfiguration);
    var attrConfDependentService = getCodeProperty(attrConf, 'dependent_service_attribute_id');
    if (attrConfDependentService !== '') {
      dependentAttributes.push(attr);
    }
  });
  return dependentAttributes;
};
export var showHideAttributes = function showHideAttributes(dependentAttributes, attributes, attributeConfiguration) {
  dependentAttributes.forEach(function (attr) {
    var attrConf = getCodeConfiguration(attr.ServiceAttributeId, attributeConfiguration);
    var attrConfDependentService = getCodeProperty(attrConf, 'dependent_service_attribute_id');
    var otherAttributeConf = getCodeConfiguration(attrConfDependentService, attributeConfiguration);
    var otherAttribute = otherAttributeConf ? find(propEq(parseInt(otherAttributeConf.Value, 10), 'ServiceAttributeId'))(attributes) : null;
    var attrConfDependentValue = getCodeProperty(attrConf, 'dependent_values');
    if (otherAttribute) {
      if (attrConfDependentValue.includes(',')) {
        attr.isHidden = !attrConfDependentValue.includes(otherAttribute.Value) || otherAttribute.isHidden ? true : false;
      } else {
        attr.isHidden = otherAttribute.Value !== attrConfDependentValue || otherAttribute.isHidden ? true : false;
      }
    } else {
      attr.isHidden = false;
    }
    if (attr.isHidden && attr.Editable) {
      attr.Value = null;
    }
  });
};
export var getCodeProperty = function getCodeProperty(item, propertyName) {
  var values = null;
  if (item) {
    item.AdditionalProperties.forEach(function (prop) {
      if (prop.Key === propertyName) {
        values = prop.Value;
      }
    });
  }
  return values;
};
export var getCodeConfiguration = function getCodeConfiguration(codeNum, attributeConfiguration) {
  return find(propEq(String(codeNum), 'Value'))(attributeConfiguration);
};
export var formatMultipleValues = function formatMultipleValues(value) {
  var itemsArray = [{
    label: i18n.translate(CustomerCareLocaleKeys.TAX_LABELS.SELECT),
    value: null
  }];
  value.forEach(function (val) {
    itemsArray.push({
      label: val.trim(),
      value: val.trim()
    });
  });
  return itemsArray;
};
export var getCodeTablePropertyValueByName = function getCodeTablePropertyValueByName(attribute, attributeConfiguration, propertyName) {
  var serviceAttribute = find(propEq(String(attribute.ServiceAttributeId), 'Value'))(attributeConfiguration);
  return serviceAttribute && serviceAttribute.AdditionalProperties.find(function (prop) {
    return prop.Key === propertyName;
  }).Value || undefined;
};